import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { baseURL } from '../constants/base.url';
import { Sale } from '../models/sale';

@Injectable({
  providedIn: 'root'
})
export class SaleService {

  constructor(private http: HttpClient) { }

  // ✅ Create new sale
  createSale(payload: Sale): Observable<{ success: boolean; data: Sale }> {
    return this.http.post<{ success: boolean; data: Sale }>(`${baseURL}sale`, payload);
  }

  // ✅ Get all sales with filters & pagination
  getAllSales(params?: any): Observable<{ success: boolean; data: any }> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '')
          httpParams = httpParams.set(key, params[key]);
      });
    }
    return this.http.get<{ success: boolean; data: any }>(`${baseURL}sale`, { params: httpParams });
  }

  // ✅ Get single sale by ID
  getSaleById(id: string): Observable<{ success: boolean; data: Sale }> {
    return this.http.get<{ success: boolean; data: Sale }>(`${baseURL}sale/${id}`);
  }

  // ✅ Add payment to sale
  addPayment(id: string, payload: any): Observable<{ success: boolean; data: Sale }> {
    return this.http.post<{ success: boolean; data: Sale }>(`${baseURL}sale/${id}/payment`, payload);
  }

  // ✅ Soft delete sale
  deleteSale(id: string, reason: string): Observable<{ success: boolean; data: Sale }> {
    return this.http.delete<{ success: boolean; data: Sale }>(`${baseURL}sale/${id}`, {
      body: { reason }
    });
  }

  // ===============================
  //   RESERVE API METHODS
  // ===============================

  /** 🔹 Get all reserves (pagination + filters) */
  getAllReserves(params?: any): Observable<{ success: boolean; data: any }> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
          httpParams = httpParams.set(key, params[key]);
        }
      });
    }

    return this.http.get<{ success: boolean; data: any }>(
      `${baseURL}sale/reserve/all`,
      { params: httpParams }
    );
  }

  /** 🔹 Get single reserve record by ID */
  getReserveById(id: string): Observable<{ success: boolean; data: Sale }> {
    return this.http.get<{ success: boolean; data: Sale }>(
      `${baseURL}sale/reserve/${id}`
    );
  }

  /** 🔹 Complete reserve (mark as sold/active) */
  completeReserve(id: string, markAs: 'sold' | 'active' | 'cancelled' = 'sold'):
    Observable<{ success: boolean; data: Sale }> {
    return this.http.post<{ success: boolean; data: Sale }>(
      `${baseURL}sale/reserve/${id}/complete`,
      { markAs }
    );
  }


}